export const Permission = {
  User: {
    Read: 'user-read',
    Create: 'user-create',
    Update: 'user-update',
    Delete: 'user-delete',
  },
  Car: {
    Read: 'car-read',
    Create: 'car-create',
    Update: 'car-update',
    Delete: 'car-delete',
  },
  Role: {
    Read: 'role-read',
    Create: 'role-create',
    Update: 'role-update',
    Delete: 'role-delete',
  },
  Group: {
    Read: 'group-read',
    Create: 'group-create',
    Update: 'group-update',
    Delete: 'group-delete',
  },
  Brand: {
    Read: 'brand-read',
    Create: 'brand-create',
    Update: 'brand-update',
    Delete: 'brand-delete',
  },
  Booking: {
    Read: 'booking-read',
    Create: 'booking-create',
    Update: 'booking-update',
    Delete: 'booking-delete',
  },
  Listing: {
    Read: 'listing-read',
    Create: 'listing-create',
    Update: 'listing-update',
    Delete: 'listing-delete',
  },
  Kyc: {
    Read: 'kyc-read',
    Create: 'kyc-create',
    Update: 'kyc-update',
    Delete: 'kyc-delete',
  },
  KycType: {
    Read: 'kyc-type-read',
    Create: 'kyc-type-create',
    Update: 'kyc-type-update',
    Delete: 'kyc-type-delete',
  },
  Telemetry: {
    Read: 'telemetry-read',
    Update: 'telemetry-update',
  },
  Issue: {
    Read: 'issue-read',
    Create: 'issue-create',
    Update: 'issue-update',
    Delete: 'issue-delete',
  },
  IssueType: {
    Read: 'issue-type-read',
    Create: 'issue-type-create',
    Update: 'issue-type-update',
    Delete: 'issue-type-delete',
  },
  IssueCategory: {
    Read: 'issue-category-read',
    Create: 'issue-category-create',
    Update: 'issue-category-update',
    Delete: 'issue-category-delete',
  },
  Zone: {
    Read: 'zone-read',
    Create: 'zone-create',
    Update: 'zone-update',
    Delete: 'zone-delete',
  },
  ZoneCategory: {
    Read: 'zone-category-read',
    Create: 'zone-category-create',
    Update: 'zone-category-update',
    Delete: 'zone-category-delete',
  },
  // Read-only by design: the trail is append-only, so there is nothing to create, edit or delete.
  ActivityLog: {
    Read: 'activity-log-read',
  },
} as const;

export type PermissionKey =
  (typeof Permission)[keyof typeof Permission][keyof (typeof Permission)[keyof typeof Permission]];
